module.exports = __webpack_public_path__ + "img/ic-not-found.bbac127d.png";